import * as Scrivito from "scrivito";

Scrivito.provideComponent("TextPanelWidget", ({ widget }) => (
  <Scrivito.ContentTag content={widget} attribute="headline" />
));
